import { createAsyncThunk } from "@reduxjs/toolkit";
import { CampaignBody, CampaignType } from "@vviinn/user-managment-client-ts";
import { ApiRequest, serializeModel } from "../../../api";
import { CampaignRequest } from "./types";

type AddCampaignRequest = CampaignRequest & {
  campaignBody: CampaignBody;
  campaignType: CampaignType;
};

export const upsertCampaign = createAsyncThunk(
  "campaigns/add",
  async ({ api, value }: ApiRequest<AddCampaignRequest>) => {
    const { campaignBody, companyId, siteId, campaignType } = value;
    if (!companyId) return;

    const response = await api.upsertCampaignByType(
      companyId,
      siteId,
      campaignType,
      campaignBody,
    );
    return serializeModel(response.value);
  },
);
